// extracted by mini-css-extract-plugin
export default {"container":"skeleton_container__3DRz0","item":"skeleton_item__9AUY4"};